export default function CompanyResults() {
  const results = [
    { icon: 'ri-line-chart-line', title: 'Рост конверсии', desc: 'Менеджеры начинают выигрывать больше сделок из того же потока обращений за счёт системного подхода к продажам.' },
    { icon: 'ri-money-dollar-circle-line', title: 'Рост среднего чека', desc: 'Умение продавать ценность и защищать цену увеличивает средний чек без увеличения скидок.' },
    { icon: 'ri-price-tag-3-line', title: 'Уменьшение скидок', desc: 'Менеджеры перестают использовать скидку как единственный аргумент. Маржинальность сделок растёт.' },
    { icon: 'ri-funds-line', title: 'Рост маржи', desc: 'Снижение скидок и рост среднего чека напрямую увеличивают валовую прибыль компании.' },
    { icon: 'ri-repeat-line', title: 'Рост повторных продаж', desc: 'Клиенты возвращаются, потому что менеджеры строят долгосрочные отношения и добавляют ценность.' },
    { icon: 'ri-chat-check-line', title: 'Рост качества переговоров', desc: 'Структурированные встречи, чёткая аргументация, контроль следующего шага — переговоры становятся профессиональными.' },
    { icon: 'ri-file-check-line', title: 'Единый стандарт продаж', desc: 'В компании появляется Книга продаж, скрипты и регламенты. Все менеджеры работают по единой системе.' },
    { icon: 'ri-user-add-line', title: 'Быстрая адаптация новичков', desc: 'Новые менеджеры выходят на результат в 2–3 раза быстрее благодаря стандартам и регламентам.' },
    { icon: 'ri-dashboard-line', title: 'Управляемый отдел продаж', desc: 'Руководитель видит воронку, понимает узкие места и может управлять результатом, а не гадать.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-bar-chart-grouped-line"></i>
            Бизнес-результаты
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Результаты компании после внедрения
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Системное обучение B2B-продажам приносит измеримые бизнес-результаты на всех уровнях.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {results.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-5 md:p-6 border border-gray-100 hover:border-teal-100 hover:bg-teal-50/30 transition-colors group">
              <div className="w-12 h-12 bg-teal-600/10 rounded-xl flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-teal-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}